export default "__VITE_ASSET__CL33nr7f__"